var Model = require("../../../types/Model.js");

// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;
var ReactNative = require("react-native");
const { Platform  } = ReactNative;

var READ_TIMEOUT = 1500;

module.exports = new Model({
	name: "deviceA&DWeight",
	listeners: listeners,
	triggers: triggers,
	init: init,
	uninit: uninit,

	handleProgressUpdated: handleProgressUpdated,
	handleBatteryReading: handleBatteryReading,
	handleFinishReading: handleFinishReading,
	disconnect: disconnect,
	clean: clean,
});

function init() {
	this._isListening = false;
	this._isRead = false;
	this._deviceMac = null;

	this._progress = 0;

	this._batteryReadings = [];
	this._readings = [];

	this._readCharacteristic = "ANDWEIGHT_READ_CHARACTERISTIC_EU";
	this._readService = "ANDWEIGHT_SERVICE_EU";
	this._isNA = false;
	this._hasDisconnected = false;

	this._readTimeout = null;
	return getRegion().then(function(region){
		if(region === "Canada" || region === "United States"){
			this._readCharacteristic = "ANDWEIGHT_READ_CHARACTERISTIC";
			this._readService = "ANDWEIGHT_SERVICE";
			this._isNA = true;
		}
	}.bind(this));
}

function uninit() {
	this._isListening = false;
	this._isRead = false;
	this._deviceMac = null;

	this._progress = 0;

	this._batteryReadings = [];
	this._readings = [];

	this._readCharacteristic = null;
	this._readService = null;
	this._isNA = false;
	this._hasDisconnected = false;

	clearTimeout(this._readTimeout);
	this.readTimeout = null;
}

function triggers() {
	return {
		"info": info,
		"ready": ready,
		"clean": clean,
		"disconnect": disconnected,
		"failed": failed
	};
}

function listeners() {
	return {
		"bluetooth:event": handleEvent,
	};
}

function info(){
	var trigger = "deviceweight:trigger:begin";
	var message = "myhealthdevice.a&dweightprepmessage";

	this.emit("feedbackmodal:trigger:show", {
		title: "myhealthdevice.prepare_weight",
		items: {
			prepare: {
				message: message,
				type: "confirmcancel",
				trigger: trigger,
				cancelTrigger: "myhealthdevice:trigger:clean",
				pair: "myhealthdevice:trigger:pair"
			}
		}
	});

	this.emit("usermetrics:trigger:track", "open read from device modal for weight", {
		"device type": "A&DWeight"
	});
}

function ready(data){
	this._deviceMac = data.mac;
	this._isListening = true;

	this.emit("bluetooth:trigger:read", {
		service: "DEVICE_BATTERY_SERVICE",
		characteristic: "DEVICE_BATTERY_CHARACTERISTIC",
		device: this._deviceMac
	});

	this.emit("bluetooth:trigger:listen", {
		service: this._readService,
		characteristic: this._readCharacteristic,
		device: this._deviceMac
	});
	// log(this, "WeightA&DReady", this);
}

function handleEvent(event){
	var isListening = this._isListening;
	var readings = this._readings;

	var char = event.characteristic;
	if(!isListening) return;

	var data = event.data;

	this._isRead = true;

	// log(this, "WeightA&DEvent", this);
	if(char === this._readCharacteristic){
		this._readings = readings.concat(data);
		clearTimeout(this._readTimeout);
		this._readTimeout = setTimeout(handleFinishReading.bind(this), READ_TIMEOUT);
	} else if(char === "DEVICE_BATTERY_CHARACTERISTIC"){
		this._batteryReadings = [].concat(data);
		this.handleBatteryReading();
	}
	this.handleProgressUpdated();
}

function handleProgressUpdated(){
	var progress = this._progress;

	if(progress < 2)
		progress++;

	this.emit("feedbackmodal:trigger:update", {
		reading: {
			type: "progress",
			message: "myhealthdevice.reading",
			progress: progress / 2,
			cancelTrigger: "myhealthdevice:trigger:clean"
		}
	});

	this._progress = progress;
}

function handleFinishReading(){
	var readings = this._readings;
	var isRead = this._isRead;
	if(!isRead) return;

	var reading = formatReading(readings, this._isNA);
	if(!reading) return;

	// log(this, "WeightA&DFinishReading", this);
	this.disconnect();
	this.dispatch("done", reading);
}

function disconnect(){
	var isListening = this._isListening;
	var hasDisconnected = this._hasDisconnected;

	if(isListening && !hasDisconnected){
		this._isListening = false;
		this.emit("bluetooth:trigger:listen:stop", {
			service: this._readService,
			characteristic: this._readCharacteristic,
			device: this._deviceMac
		});
	}
	// log(this, "WeightA&DDisconnect", this);
}

function disconnected(){
	this._hasDisconnected = true;
}

function failed(){
	const message = Platform.OS === "ios" ? "myhealthdevice.failed_iOS" : "myhealthdevice.failed";
	this.emit("feedbackmodal:trigger:show", {
		title: "myhealthdevice.failedtitle",
		items: {
			continue: {
				message: message,
				type: "confirmcancel",
				trigger: "myhealthdevice:trigger:begin",
				cancelTrigger: "myhealthdevice:trigger:clean",
				pair: "myhealthdevice:trigger:pair"
			}
		}
	});
	// log(this, "WeightA&DFailed", this);
}

function clean(){
	this._isListening = false;
	this._isRead = false;
	this._deviceMac = null;
	this._progress = 0;
	this._hasDisconnected = false;

	this._readings = [];
	this._batteryReadings = [];

	clearTimeout(this._readTimeout);
	this._readTimeout = null;
	// log(this, "WeightA&DCleaned", this);
}

function handleBatteryReading(){
	var readings = this._batteryReadings;
	var reading = formatBatteryReading(readings);
	this.dispatch("battery", reading);
}

function formatReading(readings, isNA) {
	var latestReadingWeight = readings[readings.length - 1];
	var unit = getUnits(latestReadingWeight);
	var reading = null;
	if(isNA) reading = parseValueNA(latestReadingWeight[2], latestReadingWeight[1]);
	else reading = parseValueEU(latestReadingWeight[2], latestReadingWeight[1], unit);
	return {
		weight: reading,
		units: unit
	};
}

function parseValueNA(value1, value2){
	var resolution = 0.1;
	var value = parseHex(value1) + parseHex(value2);
	return parseInt(value, 16) * resolution;
}

function parseValueEU(value1, value2, units){
	var resolution = units === "kg" ? 0.005 : 0.01;
	var value = parseHex(value1) + parseHex(value2);
	var reading = parseInt(value, 16) * resolution;
	return reading;
}

function getUnits(reading){
	var bytes = reading[0];
	var binary = bytes.toString(2);
	var byte = binary[binary.length - 1];

	if(byte === "0")
		return "kg";
	else if (byte === "1")
		return "lbs";
}

function formatBatteryReading(readings){
	var latestReading = readings[readings.length - 1];
	return latestReading[0];
}

function getRegion(){
	return AsyncStorage.getItem("region").then(function(region){
		if(!region) return "Canada";
		return region;
	});
}

function parseHex(value){
	var hex = value.toString(16);
	if(hex.length < 2) hex = "0" + hex;
	return hex;
}